import cn from 'classnames'
import React from 'react'

import styles from './IntegrationsPage.module.scss'

import { MAIL_TO } from '~lib/constants'
import IntegrationLayout from '~modules/integrations/elements/IntegrationsPageLayout'
import Button from '~shared/ui/Button'
import Flex from '~shared/ui/Flex'
import Text from '~shared/ui/Text'

interface IntegrationPageProps {
  heading?: string
  subheading?: string
  footer?: React.ReactNode
  children?: React.ReactNode
  className?: string
}

function IntegrationPage({ heading, subheading, children, footer, className }: IntegrationPageProps) {
  return (
    <IntegrationLayout heading={heading} subheading={subheading} className={cn(styles.root, className)}>
      <div className={styles.integrations}>{children}</div>

      <div className={styles.footer}>
        {footer}

        <Flex align="center" className={styles.note}>
          <Text variant="secondary">Want a new integration?</Text>

          <Button variant="link" fontSize="md" lineHeight="md" className="px-0-75 py-0-5">
            <a href={MAIL_TO}>Contact us</a>
          </Button>
        </Flex>
      </div>
    </IntegrationLayout>
  )
}

export default React.memo(IntegrationPage)
